// #region ORDER STATUS: ENUM

import { KeyInfoInterface } from "@/interfaces/KeyInfoInterface";
import { RestrictType } from "@/interfaces/RestrictType";

export enum OrderStatusEnum {
  DRAFT = 'draft',
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  SUBMITTED = 'submitted',
  RECEIVING = 'receiving',
  COMPLETE = 'complete',
  CANCELLED = 'cancelled',
};

// #endregion

// #region ORDER STATUS: KEY INFO

export class OrderStatusKeyInfoClass implements RestrictType<OrderStatusEnum, KeyInfoInterface, OrderStatusKeyInfoClass> {
  get [OrderStatusEnum.CANCELLED](): KeyInfoInterface {
    return {
      label: 'Cancelled',
      labelShort: 'Cancelled',
    }
  }

  get [OrderStatusEnum.DRAFT](): KeyInfoInterface {
    return {
      label: 'Draft',
      labelShort: 'Draft',
    }
  }

  get [OrderStatusEnum.PENDING](): KeyInfoInterface {
    return {
      label: 'Pending',
      labelShort: 'Pending',
    }
  }

  get [OrderStatusEnum.CONFIRMED](): KeyInfoInterface {
    return {
      label: 'Confirmed',
      labelShort: 'Confirmed',
    }
  }

  get [OrderStatusEnum.SUBMITTED](): KeyInfoInterface {
    return {
      label: 'Submitted',
      labelShort: 'Submitted',
    }
  }

  get [OrderStatusEnum.RECEIVING](): KeyInfoInterface {
    return {
      label: 'Receiving',
      labelShort: 'Receiving',
    }
  }

  get [OrderStatusEnum.COMPLETE](): KeyInfoInterface {
    return {
      label: 'Complete',
      labelShort: 'Complete',
    }
  }
}

export const OrderStatusKeyInfo = new OrderStatusKeyInfoClass();

// #endregion
